export const Types = {
    GET_EQUIPMENT_NOTES : "GET_EQUIPMENT_NOTES",
    SET_EQUIPMENT_NOTES : "SET_EQUIPMENT_NOTES",

    ADD_EQUIPMENT_NOTE: "ADD_EQUIPMENT_NOTE",

    UPDATE_EQUIPMENT_NOTE: "UPDATE_EQUIPMENT_NOTE",
    UPDATE_EQUIPMENT_NOTE_RESPONSE: "UPDATE_EQUIPMENT_NOTE_RESPONSE",

    DELETE_EQUIPMENT_NOTE: "DELETE_EQUIPMENT_NOTE",

    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK"
}

export const getEquipmentNotes = (payload) => ({
    type: Types.GET_EQUIPMENT_NOTES,
    payload: payload
});
export const setEquipmentNotes = (payload) => ({
    type: Types.SET_EQUIPMENT_NOTES,
    payload: payload,
});

export const addEquipmentNote = (payload) => ({
    type: Types.ADD_EQUIPMENT_NOTE,
    payload: payload,
});

export const updateEquipmentNote = (payload) => ({
    type: Types.UPDATE_EQUIPMENT_NOTE,
    payload: payload,
});

export const setUpdateEquipmentNote = (payload) => ({
    type: Types.UPDATE_EQUIPMENT_NOTE_RESPONSE,
    payload: payload,
});

export const deleteEquipmentNote = (payload) => ({
    type: Types.DELETE_EQUIPMENT_NOTE,
    payload: payload,
});


export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});